<app-login-header></app-login-header>
<div class="container page-content">
    <div class="template-detail">
        
    <div class="mb-3"><h4>Forgot Password</h4></div>
        <form [formGroup]="forgotPasswordForm" class="example-form">
            <div class="mb-3">
                <div class="col-sm-12">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label class="form-label" for="userID">UserId :</mat-label>
                        <input matInput formControlName="userID" [errorStateMatcher]="matcher" required
                            class="form-control">
                        <mat-error *ngIf="forgotPasswordForm.get('userID')?.hasError('required')">User Id is
                            required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <mat-error>{{loginFailedMessage}}</mat-error>
            <div class="d-flex justify-content-end mb-4 mt-4">
                <button mat-raised-button type="button" id="submit" class="btn btn-primary"
                    [disabled]="forgotPasswordForm.invalid" (click)="onSubmit()">Submit</button>
            </div>

        </form>
    </div>
</div>
<app-footer></app-footer>